import http from 'utils/http';
import { Operator, OperatorRequest } from './types';
import { getOperatorsUrl, getOperatorUrl } from './apiUrls';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';

export function getOperators(params: any): Promise<{ data: Operator[]; meta: MetaApiResponse }> {
  return http.get(getOperatorsUrl(), params);
}

export function getOperator(id: string): Promise<Operator> {
  return http.get(getOperatorUrl(id));
}

export function createOperator(payload: OperatorRequest): Promise<Operator> {
  return http.post(getOperatorsUrl(), payload);
}

export function updateOperator(id: string, payload: OperatorRequest): Promise<Operator> {
  return http.patch(getOperatorUrl(id), payload);
}

export function deleteOperator(id: string): Promise<String> {
  return http.delete(getOperatorUrl(id));
}
